// eslint-disable-next-line import/named
import { ReturnTop } from 'lib-vcomponents';
import Vue from 'vue';
Vue.use(ReturnTop);
